import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    project:{
      create:{
        step1:{
          client:[],
          opposed:[],
          others:[],
          customerList:[],
        },
        step2:{},
        step3:{},
      }
    },
    userInfo:{
      fullName:'',
      icon:'',//头像存储
      groupName:'',//分组名称
      companyName:'',//公司名称
      companyShortName:''//公司简称
    },
    OCRState:false,
    approval:false,
  },
  mutations: {

  },
  actions: {

  }
})
